"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomTooltip = void 0;
var React = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var palette = _a.palette, shape = _a.shape, spacing = _a.spacing, typography = _a.typography;
    return ({
        content: {
            position: "relative",
            minWidth: function (p) { return p.minWidth; },
            background: palette.background.overlays,
            padding: spacing(2, 4),
            borderRadius: shape.borderRadius,
            "&::after": {
                content: "",
                position: "relative",
                left: "50%",
                top: "100%",
                height: 14,
                width: 1,
                background: "white",
            },
        },
        tooltipDatapoint: {
            display: "block",
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            fontWeight: typography.fontWeightBold,
        },
    });
}, { name: "VizCustomTooltip" });
var CustomTooltip = function (_a) {
    var _b = _a.label, label = _b === void 0 ? "" : _b, _c = _a.active, active = _c === void 0 ? false : _c, _d = _a.minWidth, minWidth = _d === void 0 ? 100 : _d, _e = _a.separator, separator = _e === void 0 ? ": " : _e, _f = _a.payload, payload = _f === void 0 ? [] : _f, labelFormatter = _a.labelFormatter, formatter = _a.formatter, _g = _a.hideLabel, hideLabel = _g === void 0 ? false : _g, tooltipContent = _a.tooltipContent;
    var classes = useStyles({ minWidth: minWidth });
    if (!active)
        return null;
    return (React.createElement("div", { className: classes.content },
        !hideLabel && (React.createElement(Typography_1.default, { variant: "body1", color: "textSecondary" }, labelFormatter ? labelFormatter(label, payload) : label)),
        tooltipContent
            ? tooltipContent({ payload: payload })
            : payload.map(function (_a, i) {
                var name = _a.name, value = _a.value, color = _a.color, payload = _a.payload;
                return (React.createElement("span", { className: classes.tooltipDatapoint, key: i },
                    React.createElement("span", { style: { color: color !== null && color !== void 0 ? color : payload.fill } }, "" + name + separator + " "),
                    formatter ? formatter(value) : value));
            })));
};
exports.CustomTooltip = CustomTooltip;
// Recharts searches for a child with this name, so we can have it pass
// all of the internally calculated positioning props automatically if
// we name ourselves "Tooltip".
exports.CustomTooltip.displayName = "Tooltip";
//# sourceMappingURL=CustomTooltip.js.map